import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

const BadgeIconButton = styled(IconButton)(({ theme }) => ({
  padding: '5px',
  borderRadius: '50%',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[400]}`,
  boxShadow: theme.shadows[1],
  '&:hover, &:active, &:focus': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '16px',
  },
}));

export default BadgeIconButton;
